module.exports = __webpack_public_path__ + "static/media/8-BitsMusic.ef373dfb.mp3";